exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.card-charts[data-v-86d83376] {\n  display: flex;\n  flex-direction: column;\n  justify-content: space-around;\n  width: 100%;\n  border-radius: 12px;\n  box-shadow: -5px -5px 8px rgba(255,255,255,1),\n              -2px -2px 12px rgba(255,255,255,0.5),\n               inset 2px 2px 4px rgba(255,255,255,0.1),\n               5px 5px 8px rgba(0,0,0,0.15);\n}\n.sub-card[data-v-86d83376] { width: 75%; margin: 0 auto;\n}\n", ""]);

// exports
